<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav bg-sub-nav-2 pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./memberships-pending-approval" routerLinkActive="active" class="nav-link" href="#">
      Memberships Pending Approval
      <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().memberships_pending_staff_approval > 0)">
        ({{ inboxService.getInboxCounts().memberships_pending_staff_approval }})
      </span>
    </a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
